// import isEmpty from 'lodash/isEmpty'
import axios from 'axios'
import { buildStorage, setupCache } from 'axios-cache-interceptor'
import { del, get, set } from 'idb-keyval'
import { defineNuxtPlugin } from 'nuxt/app'

import { Api } from '../api'
import { buildApiApmErrorPayload } from '../api/utils/api-apm-error'
import { getApiErrorDiagnostics } from '../api/utils/network-diagnostics'

import { config as appConfig } from '~/config'

export default defineNuxtPlugin((context) => {
  const { $i18n } = context

  const urlPrefixes = {
    frontStatic: '_static',
    frontBff: 'front/api',
    webBff: 'web/api',
  }

  const locale = $i18n.localeProperties.value

  const config = {
    progress: false,
    timeout: 60000,
    baseURL: '/',
    headers: {
      'plaid-platform': 'web',
      'plaid-version': '1.0.0',
      'plaid-store-id': locale.country,
      'plaid-language-id': locale.languageCode[locale.code],
      // значение plaid-device-id прокидывается в интерцепторе запросов
    },
    params: {
      locale: locale.code,
    },
  }

  const indexedDbStorage = buildStorage({
    async find(key) {
      const value = await get(key)

      if (!value) {
        return
      }

      return value
    },

    async set(key, value) {
      await set(key, value)
    },

    async remove(key) {
      await del(key)
    },
  })

  const clientWrapper = !appConfig.get('devConfig')
    ? (client) => {
        return setupCache(client, {
          methods: ['get', 'post'],
          ttl: 0,
          // debug: console.log,
          headerInterpreter: () => {
            return 'not enough headers'
          },

          storage: indexedDbStorage,
        })
      }
    : null

  const api = new Api({
    client: axios,
    urlPrefix: urlPrefixes,
    config,
    clientWrapper,
  })

  api.subscribe('error', ({ error }) => {
    const requestConfig = error?.config || {}
    const diagnostics = getApiErrorDiagnostics(error)

    const apiType = requestConfig.apiType || 'frontBff'
    const urlPrefix = urlPrefixes[apiType] || ''
    const requestUrl = requestConfig.url || ''
    const apiPath = requestUrl.replace(urlPrefix, '')

    const isWafBlocked = error.response?.headers?.['x-auth-marker'] === 'false'

    console.log(`Ошибка api ${apiPath}`, {
      method: requestConfig.method,
      url: requestUrl,
      diagnostics,
      response: error?.response?.data,
    })

    const {
      error: apmError,
      labels,
      custom,
    } = buildApiApmErrorPayload({
      error,
      requestConfig,
      diagnostics,
      requestUrl,
      apiPath,
      isWafBlocked,
    })

    context.$apm.captureError(apmError, { labels, custom })
  })

  return {
    provide: {
      api,
    },
  }
})
